import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { Devices, loading } from '../../../core/styles';
import theme from '../../../core/styles/theme';

import RubiconLogo from '../../assets/rubiconLogoBlackOnWhite.svg';

export const LoginPageWrapper = styled.div`
  height: auto;
  width: 100%;
  background: ${theme.brandWhite};
  display: block;
`;

export const RubiconHorizontalLogo = styled.div`
  width: 165px;
  height: 30px;
  margin: 30px 0;
  background: url("${RubiconLogo}");
  display: block;
  @media screen and (max-width: 1640px) {
    margin: 30px;
  }
  @media ${Devices.laptop} {
    margin: 30px;
  }
`;

export const LoginAreaWrapper = styled.div`
  height: auto;
  width: 100%;
  background: ${theme.brandWhite};
  display: flex;
  flex-wrap: wrap-reverse;
  margin: 0 0 50px;
`;

export const LoginFormWrapper = styled.div<{ isLoading?: boolean }>`
  width: 35%;
  min-height: 500px;
  display: inline-block;
  margin: auto;
  padding: 50px;
  @media ${Devices.laptop} {
    width: 80%;
    box-shadow: none;
    border: none;
  }
  @media ${Devices.tablet} {
    width: 100%;
  }

  ${props =>
    props.isLoading &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background: ${transparentize(0.05, theme.grayLighter)};
      }

      &:after {
        position: absolute;
        content: '';
        top: 30%;
        left: 48%;
        z-index: 1000;
        justify-items: center;
        margin: -13px 0 0 -13px;
        ${loading('26px')};
      }
    `};
`;

export const SiteWidth = styled.div`
  width: 1250px;
  display: block;
  margin: 0 auto;
  @media screen and (max-width: 1640px) {
    width: 100%;
  }
  @media ${Devices.laptop} {
    width: 100%;
  }
`;

export const LoginFormTitle = styled.h1`
  margin-bottom: 60px;
  text-align: center;
  font-size: 22px;
  line-height: 24px;
`;

export const FooterMenuContainer = styled.div`
  display: block;
  background: #f6f6f6;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
`;

export const FooterLink = styled.a`
  display: inline-block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 300;
  padding: 0 20px 0 20px;
  color: #009d90;
  border-right: 1px solid #009d90;
  &:nth-child(3) {
    border-right: 0px;
  }
`;
